import { IClientSDK } from '@sxm-web/client-sdk-core';
import {
    PayBalanceDueFn,
    initPayBalanceDueFn,
} from './domains/commerce/methods/pay-balance-due';
import {
    initUpdateBillingProfilePaymentMethodFn,
    UpdateBillingProfilePaymentMethodFn,
} from './domains/commerce/methods/update-billing-profile-payment-method';
import {
    ClaimTrialFn,
    initClaimTrialFn,
} from './domains/user/methods/claim-trial';
import {
    DeviceStatusByMagicLinkGrantFn,
    initDeviceStatusByMagicLinkGrantFn,
} from './domains/user/methods/device-status-by-magic-link-grant';
import {
    DeviceStatusByRadioIdFn,
    initDeviceStatusByRadioIdFn,
} from './domains/user/methods/device-status-by-radio-id';
import {
    DeviceStatusByVinFn,
    initDeviceStatusByVinFn,
} from './domains/user/methods/device-status-by-vin';
import {
    GetSubscriptionDetailedStateFn,
    initGetSubscriptionDetailedStateFn,
} from './domains/user/methods/get-subscription-detailed-state';
import {
    ConfirmOrderFn,
    initConfirmOrderFn,
} from './domains/commerce/methods/confirm-order';
import {
    initOauthThirdPartyFn,
    OauthThirdPartyFn,
} from './domains/user/methods/oauth-third-party';
import {
    initUpdateEmailAddressFn,
    UpdateEmailAddressFn,
} from './domains/user/methods/update-email-address';

export interface IAtlasSdk {
    domains: AtlasDomains;
}

interface AtlasDomains {
    commerce: {
        confirmOrder: ConfirmOrderFn;
        payBalanceDue: PayBalanceDueFn;
        updateBillingProfilePaymentMethod: UpdateBillingProfilePaymentMethodFn;
    };
    user: {
        claimTrial: ClaimTrialFn;
        deviceStatusByMagicLinkGrant: DeviceStatusByMagicLinkGrantFn;
        deviceStatusByRadioId: DeviceStatusByRadioIdFn;
        deviceStatusByVin: DeviceStatusByVinFn;
        getSubscriptionDetailedState: GetSubscriptionDetailedStateFn;
        oauthThirdParty: OauthThirdPartyFn;
        updateEmailAddress: UpdateEmailAddressFn;
    };
}

export class AtlasSdk implements IAtlasSdk {
    domains!: AtlasDomains;

    constructor({
        baseUrl,
        clientSdk,
    }: {
        baseUrl: string;
        clientSdk: IClientSDK;
    }) {
        this.domains = {
            commerce: {
                confirmOrder: initConfirmOrderFn({ baseUrl }),
                payBalanceDue: initPayBalanceDueFn({ baseUrl }),
                updateBillingProfilePaymentMethod:
                    initUpdateBillingProfilePaymentMethodFn({
                        baseUrl,
                    }),
            },
            user: {
                claimTrial: initClaimTrialFn({ baseUrl }),
                deviceStatusByMagicLinkGrant:
                    initDeviceStatusByMagicLinkGrantFn({ baseUrl }),
                deviceStatusByRadioId: initDeviceStatusByRadioIdFn({
                    baseUrl,
                    clientSdk,
                }),
                deviceStatusByVin: initDeviceStatusByVinFn({
                    baseUrl,
                    clientSdk,
                }),
                getSubscriptionDetailedState:
                    initGetSubscriptionDetailedStateFn({ baseUrl }),
                oauthThirdParty: initOauthThirdPartyFn({ baseUrl }),
                updateEmailAddress: initUpdateEmailAddressFn({ baseUrl }),
            },
        };
    }
}
